<template>
  <div class="container">
    <div class="bg-white">
        <span>الحافلات</span>
    </div>
    <br/>

    <GmapMap style="width: 100%; height: 600px;" :zoom="12" :center="{lat:24.7 , lng: 46.6}">
      <GmapMarker v-for="(marker, index) in markers"
        :key="index"
        :position="marker.position"
        />
      <GmapMarker
       :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          :draggable="true"
          @click="center=m.position"
        />
    </GmapMap>
  </div>
</template>

<script>
import indexLayout from "../../layouts/indexLayout.vue";
export default {
  data() {
    return {
      markers: [],
      place: null,
    }
  },
    created(){
      this.$emit('update:layout',indexLayout)
    },
  description: 'Autocomplete Example (#164)',
  methods: {
    setDescription(description) {
      this.description = description;
    },
    setPlace(place) {
      this.place = place
    },
    usePlace() {
      if (this.place) {
        this.markers.push({
          position: {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng(),
          }
        })
        this.place = null;
      }
    }
  }
}
</script>